import { memo, useMemo } from 'react';
import { WidgetGridProvider } from '@aimsos/ui';
import WIDGET_PREVIEW_DATA from '../constants/widgetPreviewData';
import { renderWidgetLibraryPreviewBody } from './widgetLibraryPreviewBody';

const MINI_BASE_WIDTH_PX = 440;
const MINI_SCALE = 0.38;
/** Max sample rows in library mini preview (list widgets / standard Widget). */
const MINI_MAX_ITEMS = 5;

const miniFrameClass =
  'w-full rounded-lg border border-edge bg-surface px-2.5 pb-2 pt-2 shadow-[0_2px_8px_rgba(0,0,0,0.08)] dark:shadow-[0_2px_8px_rgba(0,0,0,0.25)]';

const WidgetLibraryMiniPreview = ({ widget }) => {
  const miniPreviewData = useMemo(() => {
    const raw = WIDGET_PREVIEW_DATA[widget?.type];
    if (!raw) return null;
    const items = raw.items;
    if (!Array.isArray(items)) return raw;
    return { ...raw, items: items.slice(0, MINI_MAX_ITEMS) };
  }, [widget?.type]);

  const body = renderWidgetLibraryPreviewBody(widget, miniPreviewData, true);

  if (!body) {
    return (
      <div className="rounded-md border border-edge bg-brand-50/50 p-2 dark:bg-brand-950/30">
        <div className="flex h-[58px] items-center justify-center text-[9px] text-content-muted">—</div>
      </div>
    );
  }

  return (
    <div className="rounded-md border border-edge bg-brand-50/50 p-1 dark:bg-brand-950/30">
      <div className="flex h-[96px] w-full justify-center overflow-hidden rounded-md">
        <div
          className="pointer-events-none origin-top shrink-0"
          style={{
            width: MINI_BASE_WIDTH_PX,
            transform: `scale(${MINI_SCALE})`,
          }}
        >
          <WidgetGridProvider isEditMode>
            <div className={miniFrameClass}>
              <p className="mb-1.5 text-[10px] font-semibold uppercase leading-none tracking-wide text-content-muted">
                {widget?.name ?? ''}
              </p>
              {body}
            </div>
          </WidgetGridProvider>
        </div>
      </div>
    </div>
  );
};

export default memo(WidgetLibraryMiniPreview);
